import { defineMessages } from "react-intl";

export default defineMessages({
  chooseSubscriptionPlan: {
    id: "subscriptions.choosePaymentPlan",
    defaultMessage: "Choose",
  },
  RT_monthly: {
    id: "subscriptions.RT_monthly",
    defaultMessage: "Monthly",
  },
  RT_quarterly: {
    id: "subscriptions.RT_quarterly",
    defaultMessage: "Quarterly",
  },
  RT_yearly: {
    id: "subscriptions.RT_yearly",
    defaultMessage: "Yearly",
  },
  monthly_badge: {
    id: "subscriptions.monthly_badge",
    defaultMessage: "Spare",
  },
  quarterly_badge: {
    id: "subscriptions.quarterly_badge",
    defaultMessage: "Spare 20%",
  },
  yearly_badge: {
    id: "subscriptions.yearly_badge",
    defaultMessage: "Spare 35%",
  },
  monthly_payment_description: {
    id: "subscriptions.monthly_payment_description",
    defaultMessage: "So <bold> ...{currency}</bold> / month",
  },
  quarterly_payment_description: {
    id: "subscriptions.quarterly_payment_description",
    defaultMessage: "So <bold>13,33 {currency}</bold> / month",
  },
  yearly_payment_description: {
    id: "subscriptions.yearly_payment_description",
    defaultMessage: "So <bold>8,33 {currency}</bold> / month",
  },
});
